var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"display":"flex","align-items":"center","margin-bottom":"16rem"}},[_c('img',{staticClass:"icon",attrs:{"src":_vm.oss+'icon.png',"alt":""}}),_c('span',{staticStyle:{"font-weight":"600","font-size":"24rem","color":"#1E3AA2"}},[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }